import React, { useState, useCallback } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { track } from 'core/helpers/analytics';
import useSession from 'core/hooks/use-session';
import { AgencyTabs } from './components/agency-tabs';
import routes from './routes';

const PortalPage = ({ src, title }) => {
  return (
    <iframe
      src={src}
      title={title}
      style={{
        width: '100%',
        height: 'calc(100vh - 220px)',
        border: '1px solid #ccc',
        padding: 'none'
      }}
    />
  );
};

PortalPage.propTypes = {
  src: PropTypes.node,
  title: PropTypes.string
};

const AgencyPortal = () => {
  const history = useHistory();
  const { isAgency, user } = useSession();
  // commenting out because we are turning off the confirm email splash page (FOR NOW)
  // const [showSplashPage, setShowSplashPage] = useState(false);
  const [activeTab, setActiveTab] = useState(() => {
    const pathName = history.location.pathname.slice(8);
    return routes.findIndex((route) => route.route === pathName);
  });

  const handleTabChange = useCallback(
    (_, tab) => {
      const tabName = routes[tab].title;
      track(`Agency Portal - ${tabName} Tab Clicked`, {
        isAgency,
        affinityCode: user.affinityCode
      });
      setActiveTab(tab);
      history.push(`/portal/${routes[tab].route}`);
    },
    [setActiveTab, history, isAgency, user.affinityCode]
  );

  return (
    <Grid container justify-content="space-between" align-items="center">
      <AgencyTabs activeTab={activeTab} handleTabChange={handleTabChange} setActiveTab={setActiveTab} />
      <Switch>
        {routes.map(({ route, src, title }) => (
          <Route key={route} path={`/portal/${route}`}>
            <PortalPage src={src} title={title} />
          </Route>
        ))}
      </Switch>
    </Grid>
  );
};

export default AgencyPortal;
